import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, reactive } from 'vue'
interface CoordinateProps {
  client: {
    x: number
    y: number
  }
  elePosition: {
    left: number
    top: number
  }
}

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const coordinate = ref<CoordinateProps>({
  client: { x: 0, y: 0 },
  elePosition: { left: 0, top: 0 }
})
const dragBox = ref<HTMLElement>(null)
const touchstartHandle = (refName, e) => {
  const element = e.targetTouches[0]
  // 记录点击的坐标
  coordinate.value.client = {
    x: element.clientX,
    y: element.clientY
  }
  // 记录需要移动的元素坐标
  coordinate.value.elePosition.left = dragBox.value.offsetLeft
  coordinate.value.elePosition.top = dragBox.value.offsetTop
  // e.preventDefault()
}
const touchmoveHandle = (refName, e) => {
  const element = e.targetTouches[0]
  // 根据初始 client 位置计算移动距离(元素移动位置=元素初始位置+光标移动后的位置-光标点击时的初始位置)
  let x =
    coordinate.value.elePosition.left +
    (element.clientX - coordinate.value.client.x)
  let y =
    coordinate.value.elePosition.top +
    (element.clientY - coordinate.value.client.y)
  // 限制可移动距离，不超出可视区域
  x =
    x <= 0
      ? 0
      : x >= innerWidth - dragBox.value.offsetWidth
      ? innerWidth - dragBox.value.offsetWidth
      : x
  y =
    y <= 0
      ? 0
      : y >= innerHeight - dragBox.value.offsetHeight
      ? innerHeight - dragBox.value.offsetHeight
      : y
  // 移动当前元素
  dragBox.value.style.left = x + 'px'
  dragBox.value.style.top = y + 'px'
  // e.preventDefault()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "dragBox",
    ref: dragBox,
    class: "myPostcard",
    onTouchstart: _cache[0] || (_cache[0] = ($event: any) => (touchstartHandle('dragBox', $event))),
    onTouchmove: _cache[1] || (_cache[1] = ($event: any) => (touchmoveHandle('dragBox', $event)))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 544))
}
}

})